import { render, staticRenderFns } from "./EventModal.vue?vue&type=template&id=ddde1ec8&scoped=true"
import script from "./EventModal.vue?vue&type=script&lang=js"
export * from "./EventModal.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./EventModal.vue?vue&type=style&index=1&id=ddde1ec8&prod&lang=css"
import style2 from "./EventModal.vue?vue&type=style&index=2&id=ddde1ec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddde1ec8",
  null
  
)

export default component.exports